/**
 * Start catalog/countries load once per session when CMS boot data is present.
 * `form/loadInitialData` is deduped in the store.
 */
export function schedulePrefetchFormCatalog(store) {
    if (typeof window === 'undefined') return;
    const hasBootData = window.__APP_DATA__ && typeof window.__APP_DATA__ === 'object';
    const hasCheckoutUi = document.querySelector(
        'shopping-cart, buy-vignette, #pricing-app, #how-it-works-validity-check-app'
    );
    if (!hasBootData && !hasCheckoutUi) return;
    store.dispatch('form/loadInitialData').catch(() => {});
}
